import React from 'react';
import { Form, Input } from 'antd';
import { Controller } from 'react-hook-form';

const Note = ({
  label,
  name,
  control,
  rules,
  errors,
  required = false,
  placeholder = 'Nhập nội dung',
}) => {
  return (
    <Form.Item
      label={label}
      validateStatus={errors?.[name] ? 'error' : undefined}
      help={errors?.[name]?.message}
      required={required}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            onChange={(e) => field.onChange(e.target.value)}
            placeholder={placeholder}
            autoSize={{
              minRows: 3,
              maxRows: 5,
            }}
            maxLength={500}
            showCount
          />
        )}
      />
    </Form.Item>
  );
};

export default Note;
